import { Log, assign } from '@artup/utilities'

/**
 * Assignable instance
 */
export class Assignable {
  constructor (data = {}) {
    this.assign({ ...data })
  }

  /**
   * Normalizes the data after assignment, for example converting
   * the properties to their correct types
   */
  normalize () {
  }

  /**
   * Assigns data to the instance
   * @param {Object} data Data to assign to the instance
   * @param {Dictionary<string, Function>} map Dictionary of property value mappers
   * @returns {Object} Modified instance
   */
  assign (data, map) {
    if (data) {
      assign(this, data, map)
    }
    this.normalize()
    return this
  }

  /**
   * Clones the instance.
   * @returns {Object} Instance of the same type containing all data of this instance
   */
  clone () {
    const data = JSON.parse(JSON.stringify(this))
    const clone = new this.constructor(data)
    clone.normalize()
    return clone
  }

  /**
   * Casts the specified instance into a given type.
   * Ignores and returns as-is if it's already a correct type
   * @param {Object} instance Instance to type-cast
   * @param {Function} constructor Constructor of the result class
   * @param {any} defaultValue Value to assign if instance is not specified
   * @returns {Object} Instance casted to the specified class
   */
  cast (instance, constructor, defaultValue) {
    if (instance != null && constructor) {
      if (instance.constructor == constructor) {
        return instance
      } else {
        return new constructor(instance)
      }
    } else {
      return defaultValue == null ? instance : defaultValue
    }
  }

  /**
   * Casts all instances in the specified array into a given type.
   * Ignores and returns as-is instances which are already a correct type.
   * @param {Array[Object]} instances Instance to type-cast
   * @param {Function} constructor Constructor of the result class
   * @param {any} defaultValue Value to assign if instance is not specified
   * @returns {Array[Object]} Instances casted to the specified class
   */
  castArray (instances, constructor, defaultValue) {
    if (instances != null && constructor) {
      if (Array.isArray(instances)) {
        return instances.map(instance =>
          instance == null
            ? instance
            : (instance.constructor === constructor ? instance : new constructor(instance))
        )
      } else {
        Log.warn(`Attempt to perform castArray of a non-array ${constructor.name} instance`, instances)
        // eslint-disable-next-line no-console
        console.trace()
      }
    } else {
      return defaultValue == null ? instances : defaultValue
    }
  }
}
